import _ from 'lodash'
import qc from 'qc'
import gameIframe from '@ps/bridge/iframe/iframe'
import { setNodeStyleMerge } from '@ps/bridge/qc/node/layout'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import {
  NodeGhostClass,
  getAllParentsBeforeScene,
  is2dComponentNode,
  isImage,
  isSequenceFrame,
} from '@ps/bridge/qc/base'
import { libTabNameList } from '@ps/store/workbench/resource-manager/config'
import store from '@ps/store'
import qcGame from '@ps/bridge/qc/qc-game'
import assets from '@ps/bridge/qc/assets'
import { categoryList } from '@ps/store/workbench/resource-manager/config'
import { scripts } from '@ps/bridge/qc/scripts'
import router from '@ps/router'
// 滤镜的初始数据
export function getEmptyFilters() {
  const data = {
    // 滤镜
    blur: 0,
    hue: 0,
    luminance: 0,
    saturation: 0,
  }
  return data
}

// 临时资源节点组
export const getTempResNode = (
  componentNode: qc.Node | null,
): qc.Node | null => {
  if (!componentNode) return null
  let tempResourceNode = componentNode.getChild('tempResource')
  if (tempResourceNode) return tempResourceNode
  tempResourceNode = gameIframe.qcGame.add.node(componentNode)
  tempResourceNode.name = 'tempResource'
  tempResourceNode.visible = false
  setNodeStyleMerge(tempResourceNode, { visible: 0 })
  const data = editorScript.getScript(tempResourceNode)
  data.$data.nodeType = NodeGhostClass
  return tempResourceNode
}
// 添加资源
export function addResource(config: {
  targetNode: qc.Node
  rules: string[]
  rename?: string
  callback: any
}) {
  const data = {
    poolTabList: ['resourcePool', 'commonResource'],
    playComponentResource: true,
    currentTab: libTabNameList.PROJECT,
    currentChildTab: '',
    ...config,
    targetNode: {
      uuid: config.targetNode.uuid,
    },
  }
  if (config.rename) {
    data.rename = config.rename
  }
  if (config.callback) {
    data.callback = config.callback
  }
  console.log(data)
  store.commit('workspace/resourceManager/closeLibDialog')
  store.commit('workspace/resourceManager/updatePoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: 'commonResource',
    action: 'add',
  })
  store.commit('workspace/resourceManager/moveLibDialogNextToRight')
}
// 替换资源
export function updateResource(node: qc.Node, callback: any) {
  const updateNode = node || store.state.workspace.game.activeNode
  const getCategory = (node: qc.Node) => {
    if (isImage(node)) {
      return categoryList.image.category
    } else if (isSequenceFrame(node)) {
      // 暂不支持序列帧节点资源替换
      return categoryList.aImage.category
    }
    return categoryList.image.category
  }
  const category = getCategory(updateNode)

  const onReplaced = () => {
    console.log('替换回调')
    //
    callback && callback()
  }
  const data = {
    targetNode: {
      uuid: node.uuid,
    },
  }
  store.commit('workspace/resourceManager/assignPoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: category,
    action: 'update',
    onReplaced,
  })
  store.dispatch('workspace/resourceManager/getComponents', {
    category: category,
  })
  store.commit('workspace/resourceManager/moveDialogToRight')
}

// 添加辅助资源节点
export async function addTempResNodeByUrl(
  url: string,
  componentNode: qc.Node,
): qc.Node | null {
  const tempResNode = getTempResNode(componentNode)
  if (!tempResNode) return null
  let node = tempResNode.children.find(
    (child) => child.texture && child.texture.atlas.url === url,
  )
  if (node) {
    store.dispatch('workspace/game/updateActiveNode', {
      node,
      record: false,
    })
    const layout = node.getScript('ps.Layout')
    if (layout) {
      layout.enable = false
      node.removeScript(layout)
    }
    return node
  }
  node = qcGame.add.image(tempResNode)
  const asset = await assets.load({ url })
  const Texture = gameIframe.qc.Texture
  node.texture = new Texture(asset, 0)
  store.dispatch('workspace/game/updateActiveNode', {
    node,
    record: false,
  })
  const layout = node.getScript('ps.Layout')
  if (layout) {
    layout.enable = false
    node.removeScript(layout)
  }
  return node
}
// 画圆形到图片节点中
export const drawCircle = (node: qc.Node) => {
  const bitmapData = gameIframe.qcGame.phaser.make.bitmapData(
    node.width,
    node.height,
  )
  const context = bitmapData.context
  // 设置圆的属性
  const centerX = node.width / 2 // 圆心的x坐标
  const centerY = node.height / 2 // 圆心的y坐标
  const radiusX = node.width / 2 // 水平半径
  const radiusY = node.height / 2 // 垂直半径
  const color = 'rgba(243, 173, 2, 0.5)' // 圆的颜色

  // 绘制圆
  context.beginPath()
  context.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, 2 * Math.PI)
  context.fillStyle = color // 设置圆的填充颜色，此处为透明
  context.fill() // 填充圆的内部
  node.phaser.loadTexture(bitmapData)
  node.x = 0
  node.y = 0
}
// 画矩形到图片节点中
export const drawRect = (node: qc.Node) => {
  const bitmapData = gameIframe.qcGame.phaser.make.bitmapData(
    node.width,
    node.height,
  )
  const context = bitmapData.context
  // 设置矩形的属性
  const x = 0 // 矩形左上角的x坐标
  const y = 0 // 矩形左上角的y坐标
  const width = node.width // 矩形的宽度
  const height = node.height // 矩形的高度
  const color = 'rgba(243, 173, 2, 0.5)' // 矩形的颜色

  // 绘制矩形
  context.fillStyle = color // 设置矩形的填充颜色
  context.fillRect(x, y, width, height) // 使用fillRect方法绘制矩形
  node.phaser.loadTexture(bitmapData)
  node.x = 0
  node.y = 0
}

// 根据imageData渲染canvas
export function renderImageData(
  imageData: ImageData,
  canvas: HTMLCanvasElement,
) {
  const ctx = canvas.getContext('2d')
  if (!ctx) return
  let tempCanvas = document.createElement('canvas')
  const tempCtx = tempCanvas.getContext('2d')
  if (!tempCtx) return
  tempCanvas.width = imageData.width
  tempCanvas.height = imageData.height

  tempCtx.putImageData(imageData, 0, 0)
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(tempCanvas, 0, 0, canvas.width, canvas.height)
  tempCanvas = null
}

// 清空canvas画图
export const clearShape = (node: qc.Node) => {
  node.phaser.loadTexture(null)
}
// 根据节点获取其在玩法组件中的路径序号索引
export function getRouteIndexByNodeInComponentNode(node: qc.Node) {
  if (!node || is2dComponentNode(node)) {
    return ''
  }
  const nodeArr = []
  nodeArr.push(node.parent.getChildIndex(node))
  // 节点在玩法组件中的每层相对路径的childIndex,防止同名节点的问题
  while (node && !is2dComponentNode(node.parent)) {
    node = node.parent
    if (node) {
      nodeArr.push(node.parent.getChildIndex(node))
    }
  }
  nodeArr.reverse()
  return nodeArr.join('/')
}

// 根据序号索引路径获取玩法组件中的节点
export function findChildByRouteIndexInComponentNode(
  componentNode: qc.Node,
  routeIndex: string,
) {
  if (routeIndex === '') {
    return componentNode
  }
  const routeIndexArr = routeIndex.split('/')
  let node = componentNode
  routeIndexArr.forEach((item: string) => {
    node = node.getChildAt(Number(item))
  })
  return node
}
// 是否玩法组件里的子节点
export function has2dComponentParent(node: qc.Node) {
  const list: [qc.Node] = getAllParentsBeforeScene(node) as [qc.Node]
  return list && list.some((node) => is2dComponentNode(node))
}
// 根据图片的宽高和容器的宽高，得到图片的新宽高，把图片自适应进去容器中
export function adaptePictureSize(
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number,
) {
  const widthRatio = containerWidth / imageWidth
  const heightRatio = containerHeight / imageHeight
  const scaleFactor = Math.min(widthRatio, heightRatio)
  const width = imageWidth * scaleFactor
  const height = imageHeight * scaleFactor
  return {
    width,
    height,
  }
}
// 获取节点的图片链接
export function getImageUrl(node: qc.Node) {
  let url = ''
  if (isSequenceFrame(node)) {
    url = getSequenceFrameFirstFrame(node)
  } else {
    url = _.get(node, 'texture.atlas.img.currentSrc') || ''
  }
  return url
}
// 获取序列帧首帧
export function getSequenceFrameFirstFrame(node: qc.Node) {
  const mc = node.getScript(scripts.movieClip.name)
  const list = mc.data[mc.currentFrameName].split(',')
  if (list.length > 0) {
    let url = list[0].replace(/\.bin$/, '.png')
    url = `/project/preview/${router.currentRoute.query.id}/${url}`
    return url
  }
  return ''
}
// 获取序列帧中所有图片
export function getSequenceFrameAllImage(node: qc.Node) {
  const mc = node.getScript(scripts.movieClip.name)
  const list = mc.data[mc.currentFrameName].split(',')
  const urls = list.map((item: string) => {
    return item.replace(/\.bin$/, '.png')
  })
  return { urlList: urls, resourceUrlList: list }
}

// 获取图片的相对路径
export function getImageRelativeUrl(url: string, resourceUrl: string) {
  const ext = url.slice(url.lastIndexOf('.'))
  return resourceUrl.replace(/\.bin$/, ext)
}
// 获取图片的绝对路径
export function getAbsoluteUrl(url: string) {
  return `/project/preview/${router.currentRoute.query.id}/${url}`
}

// 链接格式转为bin
export function transform2bin(url: string) {
  return url.replace(/\.(png|jpg)$/i, '.bin')
}

// 获取节点的绝对路径，不带域名
export function getAbsoluteUrlByNode(node: qc.Node | undefined): string {
  if (!node) return ''
  let url = ''
  if (isSequenceFrame(node)) {
    url = getSequenceFrameFirstFrame(node)
  } else {
    const imageUrl = _.get(node, 'texture.atlas.img.currentSrc') || ''
    const binUrl = _.get(node, 'texture.atlas.url') || ''
    url = getImageRelativeUrl(imageUrl, binUrl)
    url = getAbsoluteUrl(url)
  }
  return url
}
